module.exports = __webpack_public_path__ + "static/media/others.ee860ddf.JPG";